import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { SeguridadService } from './seguridad.service';
import { IResponse } from '../pages/base/interfaces';
import { Global } from '../../global';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    prefix = Global.PREFIX_RECORD;
    /**
     * Url correspondiente a los servicios de autenticación.
     */
    url = `${environment.host}/auth`;
    /**
     * Cuerpo de la consulta a ser realizada.
     */
    body: any = {};
    /**
     * Cabecera de las consultas de autenticación al servidor.
     */
    header: any = {
    };

    seguridad = new SeguridadService();

    constructor(
        private http: HttpClient,
    ) { }

    async login(body: any): Promise<IResponse> {
        let header = new HttpHeaders();
        header = header.append('api_username', environment.API_USERNAME);
        header = header.append('api_password', environment.API_PASSWORD);
        header = header.append('web', 'true');
        header = header.append('version', environment.VERSION);
        try {
            const resp: any = await lastValueFrom(this.http.post(`${this.url}/login`, body, { headers: header }));
            if (resp.ok) {
                const userData = resp.resp.usuario;
                const token = resp.resp.token;
                this.seguridad.setCurrentUser(userData);
                this.seguridad.setToken(JSON.stringify(token));
                this.seguridad.setPassword(body.password);
                return { ok: true, msg: 'Login exitoso', resp: userData };
            } else {
                return resp;
            }
        } catch (error: any) {
            return await this.errorMessage(error);
        }
    }

    async cambiarContrasenha(codigo: string, resetear: boolean, nuevaContrasenha: string, viejaContrasenha?: string): Promise<IResponse> {
        try {
            let headers = new HttpHeaders();
            headers = headers.append('api_username', environment.API_USERNAME);
            headers = headers.append('api_password', environment.API_PASSWORD);
            headers = headers.append('x-token', this.seguridad.getToken());
            // headers = headers.append('x-token', localStorage.getItem(`${this.prefix}.token`)!)
            const body = {
                usuario: codigo,
                resetear,
                viejaContrasenha,
                nuevaContrasenha
            }
            if (resetear) {
                delete body.viejaContrasenha;
            }
            const url = `${this.url}/update-password`;
            const resp = await lastValueFrom(this.http.post<any>(`${url}`, body, {headers: headers}));
            return resp;
        } catch(error: any) {
            return await this.errorMessage(error);
        }
    }

    /**
     * Obtiene el usuario logueado actual.
     * @returns el usuario actual como modelo de account.
     */
    getCurrentUser(): any | null {
        return this.seguridad.getCurrentUser();
    }

    /**
     * Cierra una sesión activa.
     */
    async logout(): Promise<IResponse> {
        const usuario = this.seguridad.getCurrentUser();
        if ( usuario ) {
            let header = new HttpHeaders();
            header = header.append('api_username', environment.API_USERNAME);
            header = header.append('api_password', environment.API_PASSWORD);
            header = header.append('web', 'false');
            header = header.append('version', environment.VERSION);
            try {
                const body = {
                    usuario: usuario.codigo
                }
                const resp: any = await lastValueFrom(this.http.post(`${this.url}/logout`, body, { headers: header }));
                if (resp.ok) {
                    this.seguridad.setToken();
                    this.seguridad.setCurrentUser();
                    this.seguridad.setPassword();
                }
                return resp;
            } catch (error: any) {
                return await this.errorMessage(error);
            }
        } else {
            this.seguridad.setToken();
            this.seguridad.setCurrentUser();
            this.seguridad.setPassword();
            return { ok: true, msg: '', resp: '' };
        }
    }

    async errorMessage( error: any ) {
        if (error.error) {
            let resp = error.error
            if ( error.error instanceof ProgressEvent ) {
                resp = 'El servidor no responde'
            }
            if ( error?.status === 401 ) {
                return { ok: false, msg: error.error.msg, resp: error.error.resp };
            }
            return { ok: false, msg: 'Ha ocurrido un error inesperado', resp };
        } else {
            return { ok: false, msg: 'No se pudo conectar con el servidor', resp : 'Verifique su conexión a internet y vuelva a intentar' }
        }
    }


}
